import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { describeReengageFilter } from "../utils/buildReengageFilter";

interface SourceCriteriaChipsProps {
	filter?: string | null;
}

export const SourceCriteriaChips: FunctionComponent<SourceCriteriaChipsProps> = ({ filter }) => {
	const { t } = useTranslation();
	const chips = describeReengageFilter(filter, t);

	if (chips.length === 0) {
		return null;
	}

	return (
		<div className="flex flex-wrap gap-1 mt-1.5">
			{chips.map((chip) => (
				<span
					key={chip}
					className="inline-flex items-center gap-1 rounded border border-border bg-background-light px-1.5 py-0.5 text-[11px] text-text"
				>
					{chip}
				</span>
			))}
		</div>
	);
};
